import { useNavigate } from "react-router-dom";

const AcademyClassesPlans = () => {
  const navigate = useNavigate();

  const planCategories = [
    {
      title: "Monthly Packages",
      description: "Flexible monthly swimming instruction packages",
      plans: [
        {
          id: "basic-monthly",
          title: "Basic",
          description: "Perfect for beginners or busy schedules. Stay consistent, even once a week!",
          price: "320 AED",
          sessions: "4 sessions",
          features: [
            "4 sessions / month (1 per week)",
            "AED 80 per session",
            "4-5 person per session",
            "45 min session",
            "valid for 30 days",
            "Best for new starters",
          ],
          buttonText: "Select Basic Package",
          buttonVariant: "gray"
        },
        {
          id: "recommended-monthly",
          title: "★ Recommended",
          description: "Our most popular choice - balance between progress & flexibility!",
          price: "600 AED",
          sessions: "8 sessions",
          features: [
            "8 sessions / month (2 per week)",
            "AED 75 per session",
            "4-5 person per session",
            "45 min session",
            "valid for 30 days",
            "⭐ Great value,Faster progress, Consistent routine"
          ],
          buttonText: "Select Recommended Package",
          buttonVariant: "blue",
          popular: true
        },
        {
          id: "pro-monthly",
          title: "Pro",
          description: "Train like a pro! Ideal for faster progress and higher levels.",
          price: "840 AED",
          sessions: "12 sessions",
          features: [
            "12 sessions / month (3 per week)",
            "AED 70 per session",
            "5-6 person per session",
            "45min -1hr session for high levels",
            "valid for 30 days",
            "For serious swimmers, High-level skills training,Maximum improvement"
          ],
          buttonText: "Select Pro Package",
          buttonVariant: "gray"
        }
      ]
    },
    {
      title: "Term Packages (3 Months) - Once a Week",
      description: "Long-term swimming development with weekly sessions",
      plans: [
        /*
        {
          id: "basic-term-once",
          title: "Basic",
          description: "Maintain your water confidence steadily over the term.",
          price: "865 AED",
          sessions: "12 sessions",
          features: [
            "12 sessions (1 per week)",
            "AED 72 per session",
            "4-5 person per session",
            "valid for 3 months",
          ],
          buttonText: "Select Basic Term Package",
          buttonVariant: "gray"
        },
        */
        {
          id: "recommended-term-once",
          title: "★ Recommended",
          description: "Best balance of value & progress, Popular choice",
          price: "1050 AED",
          sessions: "15 sessions",
          features: [
            "15 sessions (1 per week)",
            "AED 70 per session",
            "4-5 person per session",
            "45 min session",
            "valid for 15 weeks",
          ],
          buttonText: "Select Recommended Term Package",
          buttonVariant: "blue",
          popular: true
        },
        /*
        {
          id: "pro-term-once",
          title: "Pro",
          description: "Intensive weekly swimming program",
          price: "1200 AED",
          sessions: "18 sessions",
          features: [
            "18 sessions (1.5 per week)",
            "AED 66.7 per session",
            "5-6 person per session",
            "45min-1hr session for high levels",
            "valid for 3 months",
          ],
          buttonText: "Select Pro Term Package",
          buttonVariant: "gray"
        }
        */
      ]
    },
    {
      title: "Term Packages (3 Months) - Twice a Week",
      description: "Accelerated swimming development with bi-weekly sessions",
      plans: [
        /*
        {
          id: "basic-term-twice",
          title: "Basic",
          description: "Double the frequency, double the improvement!",
          price: "1800 AED",
          sessions: "24 sessions",
          features: [
            "24 sessions (2 per week)",
            "AED 75 per session",
            "4-5 person per session",
            "45 min session",
            "valid for 3 months",
            "Perfect for building rhythm, Consistent improvement",
          ],
          buttonText: "Select Basic Bi-Weekly Package",
          buttonVariant: "gray"
        },
        */
        {
          id: "recommended-term-twice",
          title: "★ Recommended",
          description: "Best value for fast-track swimmers – most enrolled plan",
          price: "2100 AED",
          sessions: "30 sessions",
          features: [
            "30 sessions (2 per week)",
            "AED 70 per session",
            "4-5 person per session",
            "45 min session",
            "valid for 15 weeks",
            "Best-selling package, Great results in less time"
          ],
          buttonText: "Select Recommended Bi-Weekly Package",
          buttonVariant: "blue",
          popular: true
        },
        {
          id: "pro-term-twice",
          title: "Pro",
          description: "High-performance plan for serious swimmers!",
          price: "2400 AED",
          sessions: "36 sessions",
          features: [
            "36 sessions (3 per week)",
            "AED 66.7 per session",
            "5-6 person per session",
            "45min-1hr session for high levels",
            "valid for 3 months",
            "Intensive training plan, Ideal for competitions & high goals"
          ],
          buttonText: "Select Pro Bi-Weekly Package",
          buttonVariant: "gray"
        }
      ]
    }
  ];

  const handleSelectPlan = (plan) => {
    navigate('/enrollment-form', { state: { selectedPlan: plan } });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12">
          <button 
            onClick={() => navigate('/')}
            className="flex items-center text-blue-600 hover:text-blue-700 mb-6 transition-colors"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-arrow-left h-5 w-5 mr-2"
            >
              <path d="m12 19-7-7 7-7"></path>
              <path d="M19 12H5"></path>
            </svg>
            Back to Services
          </button>
          <div className="text-center">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">Academy Classes Packages</h1>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Choose the perfect package for your child
            </p>
          </div>
        </div>

        {planCategories.map((category, categoryIndex) => (
          <div key={categoryIndex} className="mb-16">
            <div className="text-center mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-2">{category.title}</h2>
              <p className="text-gray-600">{category.description}</p>
            </div>
            <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
              {category.plans.map((plan) => (
                <div 
                  key={plan.id}
                  className={`relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300 cursor-pointer border ${plan.popular ? 'border-2 border-blue-500 ring-4 ring-blue-100' : 'border-gray-200'}`}
                >
                  {plan.popular && (
                    <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                      <div className="bg-blue-500 text-white px-4 py-2 rounded-full text-sm font-semibold flex items-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-crown h-4 w-4 mr-1"
                        >
                          <path d="m2 4 3 12h14l3-12-6 7-4-7-4 7-6-7zm3 16h14"></path>
                        </svg>
                        Most Popular
                      </div>
                    </div>
                  )}
                  <div className="text-center mb-6">
                    <h3 className="text-2xl font-bold text-gray-900 mb-2">{plan.title}</h3>
                    <p className="text-gray-600 mb-4">{plan.description}</p>
                    <div className="mb-4">
                      <span className="text-4xl font-bold text-gray-900">{plan.price}</span>
                      <span className="text-gray-600 ml-2">/ {plan.sessions}</span>
                    </div>
                  </div>
                  <div className="space-y-3 mb-8">
                    {plan.features.map((feature, index) => (
                      <div key={index} className="flex items-center">
                        <div className="bg-green-100 rounded-full p-1 mr-3">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-check h-4 w-4 text-green-600"
                          >
                            <path d="M20 6 9 17l-5-5"></path>
                          </svg>
                        </div>
                        <span className="text-gray-700">{feature}</span>
                      </div>
                    ))}
                  </div>
                  <button 
                    onClick={() => handleSelectPlan(plan)}
                    className={`w-full py-3 px-6 rounded-lg font-semibold transition-colors ${
                      plan.buttonVariant === 'blue' 
                        ? 'bg-blue-600 text-white hover:bg-blue-700' 
                        : 'bg-gray-100 text-gray-900 hover:bg-gray-200'
                    }`}
                  >
                    {plan.buttonText}
                  </button>
                </div>
              ))}
            </div>
          </div>
        ))}

        <div className="text-center mt-16">
          <p className="text-gray-600 mb-4">Need help choosing the right package?</p>
          <button className="text-blue-600 hover:text-blue-700 font-semibold">
            Contact our education consultants
          </button>
        </div>
      </div>
    </div>
  );
};

export default AcademyClassesPlans;